import { useState, useEffect } from 'react';

export const useSyllabusLoader = (selectedCourse) => {
  const [syllabusContent, setSyllabusContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSyllabus = async () => {
      if (!selectedCourse) {
        setSyllabusContent('');
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Try to load from syllabi directory first
        const response = await fetch(`/syllabi/${selectedCourse.file}`);
        
        if (response.ok) {
          const content = await response.text();
          setSyllabusContent(content);
        } else {
          // Fallback message
          const content = `# ${selectedCourse.title}\n\nSyllabus content is being generated. Please check back soon!`;
          setSyllabusContent(content);
        }
      } catch (err) {
        console.error('Error loading syllabus:', err);
        setError('Failed to load syllabus content');
        setSyllabusContent(`# ${selectedCourse.title}\n\nError loading syllabus content.`);
      } finally {
        setLoading(false);
      }
    };

    loadSyllabus();
  }, [selectedCourse]);

  return { syllabusContent, loading, error };
};